<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData: [
          18092,
          20728,
          24045,
          28348,
          62808,
          86097,
          79867,
          44715,
          48444,
          80415,
          56061,
          32677,
          59521,
          67560,
          18092
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          12500,
          14000,
          21500,
          23200,
          24450,
          25250,
          33300,
          4600,
        ],
        rateData: []
      },
      data: [
        {
          lineData: [
            18092,
            20728,
            24045,
            28348,
            62808,
            86097,
            79867,
            44715,
            48444,
            80415,
            56061,
            32677,
            59521,
            67560,
            18092
          ],
          barData: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            14000,
            21500,
            23200,
            24450,
            25250,
            33300,
            4600,
          ]
        },
        {
          lineData: [
            18092,
            20728,
            67560,
            38348,
            79867,
            44715,
            38092,
            56061,
            62808,
            34045,
            48444,
            20415,
            49521,
            66097,
            32677,
          ],
          barData: [
            12500,
            25250,
            14000,
            14900,
            15600,
            6500,
            8500,
            33300,
            14600,
            21500,
            23200,
            24450,
            35500,
            25000,
            8500,
          ]
        },
        {
          lineData: [
            67560,
            20728,
            24045,
            58348,
            56061,
            32677,
            59521,
            79867,
            44715,
            72808,
            46444,
            40415,
            86097,
            48092,
            48092
          ],
          barData: [
            24450,
            5000,
            4600,
            9000,
            5500,
            13000,
            8500,
            7500,
            21500,
            23200,
            8500,
            25250,
            5500,
            33300,
            4600,
          ]
        },
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'power 左中'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>